import '@gjensidige/core-typography/lib-css/index.css';

import React from 'react';
import { Title } from '@gjensidige/core-typography/lib-css/title';

import FaqList from './faq-list';
import { FaqGroupWrapperProps as Props } from './types';

import styles from '../less/faq.module.less';

const FaqGroupWrapper = ({
  group,
  label,
  hideGroupLabel = false,
  noTitle = false
}: Props) => (
  <>
    {!hideGroupLabel && (
      <Title
        tag={noTitle ? 'h2' : 'h3'}
        size="h5"
        className={styles.label}
        data-testid="group-label"
      >
        {label || group?.label}
      </Title>
    )}
    <FaqList questions={group.questions} />
  </>
);

export default FaqGroupWrapper;
